(function () {
  'use strict';

  angular
    .module('app.measure')
    .controller('MeasureCtrl', MeasureCtrl);

  MeasureCtrl.$inject = ['$scope', '$rootScope', 'measureService', '$modal', '$sce', '$window', 'TRACK_EVENTS'];
  /* @ngInject */
  function MeasureCtrl($scope, $rootScope, measureService, $modal, $sce, $window, TRACK_EVENTS) {

    $scope.currentUser = $rootScope.currentUser;
    $scope.selectedAdvertiser = 0;
    if($rootScope.sideMenuSelections.advertiserId != null || $rootScope.sideMenuSelections.advertiserId != undefined) {
         $scope.selectedAdvertiser = $rootScope.sideMenuSelections.advertiserId;
    }

    if($scope.currentUser.role.accessLevel == 'advertiser') {
        $scope.selectedAdvertiser = $scope.currentUser.company.id;
    }

    $scope.timeline = [
      {label: 'Last 7 days', value: 7, ticked: true},
      {label: 'Last 15 days', value: 15},
      {label: 'Last 30 days', value: 30},
      {label: 'Last 60 days', value: 60},
      /*{label: 'Last 90 days', value: 90}*/
    ];

    if ($rootScope.selectedPeriod.period != null) {
        angular.forEach($scope.timeline, function (item) {
            if (item.value == $rootScope.selectedPeriod.period.value) {
                item.ticked = true;
            } else {
                item.ticked = false;
            }
        })
    } else {
        $rootScope.selectedPeriod.period = {
            label: 'Last 7 days', value: 7, ticked: true
        }
    }

    $scope.getMeasureReportList = function(selected_company_id) {
      measureService.getMeasureReportList(selected_company_id, true)
        .then(function(response) {
            $scope.viewReports = response.data;
            var reportFound = null;
            if($rootScope.selectedViewReport) {
                angular.forEach($scope.viewReports, function(viewReport) {
                    if(viewReport.report_id == $rootScope.selectedViewReport) {
                        reportFound = viewReport;
                        viewReport.ticked = true;
                    }
                });
            }
            if(reportFound == null) {
                $rootScope.selectedViewReport = $scope.viewReports[0].report_id;
                changeTemplate($scope.viewReports[0]);
                $rootScope.selectedReportData = $scope.viewReports[0];
            } else {
                changeTemplate(reportFound);
                $rootScope.selectedReportData = reportFound;
            }
        })
    }

    $scope.dateRangeHandler = function(data){
        $rootScope.selectedPeriod.period = data;
        $rootScope.$broadcast('refreshDashboard', {});
    }

    $scope.$on('beforePrint', function(event, args){
        // var currentPage = 1; 
        // $scope.sumHeight = 0;
        // $scope.headerHeight = 304;
        // $scope.maxHeight = 1870;
        // $scope.sumHeight = $scope.sumHeight + $scope.headerHeight;
        // angular.forEach($scope.selectViewReport.sectionList, function(section) {
        //     section.showHeader = false;
        //     if($scope.sumHeight + section.section_height > $scope.maxHeight) {
        //         section.showHeader = true;
        //         currentPage = currentPage + 1;
        //         section.pageNo = currentPage;
        //         $scope.sumHeight = $scope.maxHeight + $scope.headerHeight;
        //         $scope.maxHeight = $scope.maxHeight + 1870;
        //     }

        //     $scope.sumHeight = $scope.sumHeight + section.section_height + 10;
        // });

        // $scope.$apply();
        setTimeout($window.print, 500);
    })

    function changeTemplate (selectViewReport) {
        $scope.selectViewReport = selectViewReport;
        $scope.viewReportName = selectViewReport.report_name;
        $scope.$apply();
        $rootScope.$broadcast('refreshDashboard', {isSelectedReportChanging: true});
    }

    var trackMixpanelEvent = function (data) {
        // Mixpanel tracking report item selected
        var sideMenu = $rootScope.sideMenuSelectedName; 
        analytics.track(
            TRACK_EVENTS.USE_REPORT.EVT_NAME,
            {
                "item": TRACK_EVENTS.USE_REPORT.ITEM_NAME,
                "report_name": data.report_name,
                "report_id": data.report_id,
                "target_type": sideMenu.type,
                "target_name": sideMenu.name,
                "target_id": sideMenu.id,
                "sub_target_type": sideMenu.subType,
                "sub_target_name": sideMenu.subName,
                "sub_target_id": sideMenu.subId,
            }
        );
    };

    $scope.selectedReport = function (data) {
        $rootScope.selectedViewReport = data.report_id;
        $rootScope.selectedReportData = data;
        changeTemplate(data);
        trackMixpanelEvent(data);
    };

    $scope.$on('refreshDashboard', function(event, args) {
        if (!args.isSelectedReportChanging && $rootScope.selectedReportData && $rootScope.sideMenuSelectedName) {
            trackMixpanelEvent($rootScope.selectedReportData);
        }
    });

    $scope.customReport = function() {
        var customReportModalInstance = $modal.open({
            scope: $scope,
            templateUrl: 'app/measure/customReport/customReport.html?app_v=deployDate',
            controller: 'customReportCtrl'
        });

        $scope.customReportModalInstance = customReportModalInstance;
    }

    $scope.printPdf = function() {
        $rootScope.$broadcast('printPdf');
    }

    $scope.$on('refreshReportList', function() {
        if($rootScope.sideMenuSelections.advertiserId != null || $rootScope.sideMenuSelections.advertiserId !== undefined) {
            $scope.selectedAdvertiser = $rootScope.sideMenuSelections.advertiserId;
        }

        $scope.getMeasureReportList($scope.selectedAdvertiser);
    })

    $scope.getMeasureReportList($scope.selectedAdvertiser);

  }
})();